import { useState } from "react";
import { Search, Plus } from "lucide-react";
import { Button } from "@shared/ui/Button";
import { Loader } from "@shared/ui/Loader";
import { Sheet } from "@shared/ui/Sheet";
import { AppPageHeader } from "@shared/ui/AppPageHeader";
import { Article, Category } from "../../support.types";
import { SupportCategoryAccordionButton } from "../SupportCategoryAccordion/SupportCategoryAccordionButton";
import { SupportArticle } from "../SupportArticle/SupportArticle";
import SupportCategoryAccordion from "../SupportCategoryAccordion/SupportCategoryAccordion";

export type Props = {
  article: Article;
  categories: Category[];
  isOpen: boolean;
  onClose: () => void;
  prev: Article | null;
  next: Article | null;
  setSheetArticleId: (articleId: string) => void;
  onSearchClick: () => void;
  onTicketClick: () => void;
};

export function SupportArticleSheet({
  article,
  categories,
  isOpen,
  onClose,
  prev,
  next,
  setSheetArticleId,
  onSearchClick,
  onTicketClick,
}: Props) {
  const [isCategoriesPanelOpen, setIsCategoriesPanelOpen] = useState(false);

  const handleNavigationClick = (article: Article) => {
    setSheetArticleId(article.id);
  };

  return (
    <Sheet
      isOpen={isOpen}
      onClose={onClose}
      className="max-w-lg overflow-auto"
      innerClassName="justify-start"
    >
      <div className="flex flex-col">
        <div className="flex items-center justify-between border-b p-4 h-16 mt-16 md:mt-0">
          <div className="flex items-center gap-2">
            <SupportCategoryAccordionButton
              onClick={() => setIsCategoriesPanelOpen(!isCategoriesPanelOpen)}
            />
            <Button
              variant="secondary"
              iconComponent={Search}
              onClick={onSearchClick}
              data-testid="support-article-search-open-modal"
            >
              Search
            </Button>
            <Button
              variant="secondary"
              iconComponent={Plus}
              onClick={onTicketClick}
              data-testid="support-article-open-ticket-modal"
            >
              Get help
            </Button>
          </div>
        </div>

        <SupportCategoryAccordion
          article={article}
          categories={categories}
          isOpen={isCategoriesPanelOpen}
          setIsOpen={setIsCategoriesPanelOpen}
          onNavigationClick={handleNavigationClick}
        />
      </div>
      <div className="flex-1 flex flex-col gap-8 px-4 py-8">
        {article ? (
          <>
            <AppPageHeader title={article.title} />
            <SupportArticle
              article={article}
              prev={prev}
              next={next}
              onNavigationClick={handleNavigationClick}
            />
          </>
        ) : (
          <Loader isFullPage />
        )}
      </div>
    </Sheet>
  );
}

export default SupportArticleSheet;
